const embedSeparator = 'ɵ';
const embedSeparatorRegex = new RegExp(embedSeparator, 'g');
export const embed = (source, meta) => {
    return [source.replace(embedSeparatorRegex, ''), JSON.stringify(meta)].join(embedSeparator);
};
export const unembed = (embeddedString) => {
    const [source, meta] = embeddedString.split(embedSeparator);
    const extractedMeta = (() => {
        try {
            return meta && JSON.parse(meta);
        }
        catch {
            return {};
        }
    })();
    return [source, extractedMeta];
};
